<template>
    <div>
        <MenuAccount_Main/>
        <DailyCostReportList/>
    </div>
</template>

<script>

import MenuAccount_Main from '@/components/menuadmin/account/accountheader/MenuAccount_Main.vue'
import DailyCostReportList from '@/components/menuadmin/account/accountreport/DailyCostReportList.vue'
export default {
    name:'dailyCostReport',
    components:{
        MenuAccount_Main,
        DailyCostReportList,
    },
}
</script>